/*
 * @Author: caiqin.xie
 * @since: 2023-06-29 15:49:13
 * @lastTime: 2023-11-10 16:32:10
 * @LastEditors: caiqin.xie
 * @message: 门店组件
 */
import React from "react";
import styles from "./index.module.scss";
import { IShop } from "@/common/types";

const storeLocation = require('../../assets/support_store_location.png')
const storeTime = require('../../assets/support_store_time.png')
const storePhone = require('../../assets/support_store_phone.png')

interface IProps {
  shopData: IShop; // 门店数据
  className?: string;
}

const ShopItem = (props:IProps) => {
  const {shopData, className} = props;

  return (
    <ul className={`${styles['shop-content']} ${className}`}>    
      <li className={styles['shop-name']}>{shopData.name}</li>
      <li className={styles['shop-info']}>
        <img src={storeLocation} />
        <span className={styles['shop-info-content']}>{shopData.detailAddress}</span>
      </li>
      <li className={styles['shop-info']}>
        <img src={storeTime} />
        <span className={styles['shop-info-content']}>{shopData.businessHours}</span>
      </li>
      <li className={styles['shop-info']}><img src={storePhone} />{shopData.phone}</li>
    </ul>
  )
}

export default ShopItem;
